var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83697 11.5064L7.83618 11.5084C7.77893 11.6573 7.74995 11.8211 7.74995 11.9914C7.74995 12.1639 7.77866 12.3286 7.83698 12.4764C7.89803 12.631 8.00236 12.7768 8.13471 12.9092L15.2142 19.9887C15.3752 20.1532 15.5694 20.2505 15.7913 20.2505C16.0169 20.2505 16.2079 20.1525 16.3683 19.9887C16.5234 19.8332 16.6129 19.651 16.6129 19.4137L16.6129 19.4107L16.6133 19.4107L16.6125 19.3965C16.6002 19.1792 16.5225 18.9929 16.3673 18.8377L16.3672 18.8376L9.52103 11.9944L16.3643 5.15114C16.5253 4.99009 16.625 4.80282 16.625 4.57512C16.625 4.34791 16.5227 4.15537 16.3664 3.99519L16.3664 3.99514L16.3621 3.99088C16.1979 3.83075 16.0068 3.74139 15.7752 3.75065L15.7752 3.75062L15.7711 3.75085C15.5538 3.76315 15.3675 3.84081 15.2122 3.99608L15.2122 3.99611L8.13471 11.0766C8.00405 11.2073 7.89868 11.3501 7.83697 11.5064Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhite);
export default __webpack_public_path__ + "static/media/arrow_left_white.f9906cd330f6bd0220de79e99777c9b1.svg";
export { ForwardRef as ReactComponent };